export default {
	seo_meta_title_leaguepass: 'NBA | Video e highlight delle partite NBA',
	seo_meta_desc_leaguepass: 'Su NBA Video sono disponibili video e highlight delle partite NBA',
	seo_meta_keywords_leaguepass: 'Video NBA, highlight NBA, spettacolari, video di basket, azioni più spettacolari, schiacciate',
	seo_meta_title_featured: 'NBA | In primo piano',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live è il tuo canale TV dell’NBA in diretta streaming, che ogni settimana ti offre 24 ore su 24 partite NBA in diretta, repliche, programmi in studio e analisi degli opinionisti',
	seo_meta_keywords_nbatv: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',
	seo_meta_title_classicgames: 'NBA | Partite classiche',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Elenco video',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | NBA TV programmi',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'Homepage NBA',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Canali',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | NBA',
	seo_meta_pre_title_categories: 'NBA | Categorie',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Categoria',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Video',
	seo_meta_pre_title_event: 'NBA | Evento',
	seo_meta_title_events: 'NBA | Eventi',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Eventi: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Ricerca',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Pagina non trovata',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Partita NBA:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | Video e highlight delle partite NBA',
	seo_meta_desc_video: 'Su NBA Video sono disponibili video e highlight delle partite NBA',
	seo_meta_keywords_video: 'Video NBA, highlight NBA, spettacolari, video di basket, azioni più spettacolari, schiacciate',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live è il tuo canale TV dell’NBA in diretta streaming, che ogni settimana ti offre 24 ore su 24 partite NBA in diretta, repliche, programmi in studio e analisi degli opinionisti',
	seo_meta_keywords_channel: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',
	seo_meta_title_tvguide: 'NBA | NBA TV palinsesto',
	seo_meta_desc_tvguide: 'NBA TV Live è il tuo canale TV dell’NBA in diretta streaming, che ogni settimana ti offre 24 ore su 24 partite NBA in diretta, repliche, programmi in studio e analisi degli opinionisti',
	seo_meta_keywords_tvguide: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',
	timezone: 'ET',
	default_feed_error_message: 'Qualcosa è andato storto, il contenuto non è disponibile. Riprova.',
	watch_in_app: 'GUARDA SULL\'APP NBA',
	no_content: 'Nessun contenuto',
	see_more: 'Vedi altri contenuti',
	now_playing: 'IN RIPRODUZIONE',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Hai raggiunto il numero massimo di video preferiti che puoi selezionare. Se desideri aggiungerne un altro, rimuovi uno di quelli già selezionati.',
	item_live: 'In diretta:',
	add_favourite_title: 'AGGIUNGI AI PREFERITI',
	remove_favourite_title: 'RIMUOVI DAI PREFERITI',
	p_channel_live: 'In diretta:',
	p_channel_schedule_title: 'Palinsesto NBA TV',
	p_channel_schedule_watch: 'Guarda',
	p_channel_schedule_no_date: 'Al momento non è disponibile alcun palinsesto.',
	p_channel_live24x7_title: 'NBA TV 24H',
	p_channel_live24x7_see_full_schedule: 'Vedi palinsesto completo',
	p_channel_live24x7_up_next: 'Prossimo programma',
	p_channel_live24x7_on_demand: 'NBA TV: On-Demand',
	p_channel_live24x7_collection: 'Collezione',
	p_channel_live24x7_demand_1_logo_text: 'Programmi originali',
	p_channel_live24x7_demand_1_show_name: 'Programmi NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programmi esclusivi NBA TV tra cui Shaqtin \'a Fool, Beyond the Paint, Game Time e Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Classic Games',
	p_channel_live24x7_demand_2_show_name: 'NBA | Partite classiche',
	p_channel_live24x7_demand_2_show_desc: 'Guarda le partite storiche in versione integrale, inclusi tutti gli incontri delle Finals dal 2000, i momenti storici del campionato e le leggende dell\'NBA',
	p_channel_clips_title: 'Clip TV NBA',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programmazione',
	p_nba_tv_shows: 'Programmi NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 ore su 24, 7 giorni su 7: tieniti informato con analisi di partita, commenti in studio,  programmi esclusivi e molto altro!',
	p_nba_tv_no_access_desc: 'Guarda le partite in diretta più i programmi e le partite storiche on-demand.',
	p_nba_tv_no_access_note: 'Alcune tramissioni possono essere oscurate',
	tv_show_item_latest_episode: 'episodio più recente',
	tv_show_item_no_latest_episode: 'nessun episodio più recente',
	see_all: 'Vedi tutto',
	header_menu_watch: 'Guarda',
	header_menu_featured: 'IN PRIMO PIANO',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Giocatori',
	videos: 'Video',
	teams: 'Squadre',
	most_searched: 'PIÙ CERCATO',
	no_result: 'Nessun dato',
	search_filter_type_most_relevant: 'Più rilevanti',
	search_filter_type_most_viewed: 'I più visti',
	search_filter_type_most_recent: 'I piu recenti',
	search_filter_type_last_30_days: 'Ultimi 30 giorni',
	search_filter_type_last_6_months: 'Ultimi 6 mesi',
	search_result_label: 'Risultati di ricerca per \'{keyword}\'',
	search_result_info: 'Visualizza tutti i risultati per {keyword}',
	search_placeholder: 'Cerca nella libreria video',
	load_more: 'Carica altro...',
	button_subscribe: 'Iscriviti',
	button_sign_in: 'Accedi',
	p_league_pass_no_access_title: 'Guarda le partite in diretta o in differita su qualsiasi dispositivo, inclusi computer, smartphone e TV!',
	p_league_pass_no_access_desc: 'Il tuo biglietto per l\'azione NBA: guarda tutto il campionato o la tua squadra preferita, scegli una singola partita o scopri tutti i pacchetti.',
	p_league_pass_no_access_note: 'Si applicano termini',
	category_title: 'Video',
	p_video_playlist_title: 'Playlist:',
	p_no_access_league_pass_title: 'Sblocca NBA League Pass per guardare:',
	p_no_access_league_pass_desc: 'Il tuo biglietto per l\'azione NBA: guarda tutto il campionato o la tua squadra preferita, scegli una singola partita o scopri tutti i pacchetti.',
	p_no_access_league_pass_terms: 'Si applicano termini',
	p_no_access_league_pass_geo_desc: 'In base alla tua posizione attuale, non puoi visualizzare questa partita tramite NBA League Pass e NBA TV. La versione archiviata di questa partita sarà disponibile 3 giorni dopo la trasmissione per gli abbonati a NBA League Pass. Vedi i palinsesti delle tue emittenti radiofoniche e televisive locali per sapere dove poter vedere o ascoltare questa partita nel tuo paese.',
	p_no_access_league_pass_not_found_desc: 'La pagina richiesta non è stata trovata.',
	p_no_access_event_not_found_desc: 'L\'evento richiesto non è stato trovato.',
	p_no_access_nba_tv_title: 'Sblocca NBA TV per guardare:',
	p_no_access_nba_tv_desc: 'Guarda le partite in diretta più programmi e partite storiche on-demand.',
	p_no_access_nba_tv_terms: 'Si applicano termini',
	p_no_access_nba_tv_geo_desc: 'In base alla tua posizione attuale, non puoi visualizzare questa partita tramite NBA League Pass e NBA TV. La versione archiviata di questa partita sarà disponibile 3 giorni dopo la trasmissione per gli abbonati a NBA League Pass. Vedi i palinsesti delle tue emittenti radiofoniche e televisive locali per sapere dove poter vedere o ascoltare questa partita nel tuo paese.',
	p_no_access_nba_tv_not_found_desc: 'La pagina richiesta non è stata trovata.',
	p_no_access_up_next: 'Prossimo programma:',
	p_video_completed_title: 'Playlist completa',
	p_video_completed_desc: 'Torna indietro per sfogliare o scopri la playlist successiva personalizzata per te',
	p_video_share_to: 'Condividi:',
	p_video_more_to_watch: 'Altri contenuti da guardare:',
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Guarda',
	p_event_button_listen: 'Ascolta',
	p_event_button_ticket: 'Biglietto',
	notfound: 'La pagina richiesta non è stata trovata.',
	notfound_desc: 'Verifica la correttezza dell\'URL.<br/> Per trovare  il contenuto desiderato, puoi anche provare a utilizzare la navigazione del sito o la funzione di ricerca.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Il tuo account NBA League Pass ha raggiunto il limite massimo di streaming. Tocca \'Continua\' per riprendere la visione su questo dispositivo.',
	modal_pcm_custom: 'Continua',
	modal_pcm_close: 'Annulla',
	modal_adobe_concurrency_header_title: 'Connessione video persa',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Il flusso streaming è stato chiuso. I possibili motivi includono il limite massimo di flussi simultanei raggiunto, la perdita di connessione di rete o un errore tecnico. Accedi di nuovo e seleziona un canale per continuare.',
	modal_adobe_concurrency_close: 'Fatto',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Questo video non può essere riprodotto sul tuo dispositivo. Fai clic <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>QUI</a> per ricevere ulteriore assistenza.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	freesample_notice_time: 'Tempo rimanente',
	freesample_notice_title: 'Goditi i tuoi {0} minuti di accesso',
	freesample_notice_desc: 'Abbonati al pacchetto completo League Pass per continuare ad accedere ai contenuti allo scadere dei {0} minuti.',
	freesample_notice_subscribe_button: 'Iscriviti',
	freesample_notice_cancel_button: 'Annulla in qualsiasi momento',
	freesample_popup_title: 'IL TEMPO A TUA DISPOSIZIONE È TERMINATO',
	freesample_popup_subtitle: 'Abbonati a League Pass per guardare contenuti della NBA ancora più straordinari.',
	freesample_popup_link: 'ULTERIORI INFORMAZIONI',
	freesample_popup_get_minutes_button: 'RICEVI {0}  MINUTI',
	reg_required_desc: 'Devi accedere per visualizzare questo contenuto',
	favorite_teams_title: 'Squadre preferite',
	bookmarked_title: 'Salvato',
	watch_history_title: 'Continua a guardare',
	game_schedule_title: 'Programmazione delle partite',
	recommended_title: 'Consigliato',
	season_text: 'Stagione',
	section_tv_provider_title: 'Il mio provider TV',
	section_tv_provider_desc: 'Ottieni l\'accesso a partite e streaming in diretta con il tuo provider TV.',
	section_tv_provider_faq: 'Domande frequenti sui provider TV',
	section_tv_provider_sign_out: 'Esci',
	header_menu_account_my_account: 'Il mio account',
	header_menu_account_manage_account: 'Gestisci account',
	header_menu_account_favorite_teams: 'Squadra preferita',
	header_menu_account_favorite_players: 'I miei giocatori preferiti',
	header_menu_account_viewing_history: 'Cronologia',
};
